import { stringify } from 'query-string'
import { API_HOME_BASE_URL, API_TIMEOUT } from 'shared/constants/defaultENV'

import { Api } from './ApiGlobals'

const HomeApi = new Api({
  baseURL: API_HOME_BASE_URL,
  timeout: API_TIMEOUT,
})

HomeApi.instance.defaults.paramsSerializer = function (params) {
  return stringify(params)
}

export default HomeApi
